<div class="header cor-master">
    <div class="title">{{titulo}}</div>
    <button class="close-button" mat-icon-button (click)="fecharDialog()">
        <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
</div>

<mat-dialog-content class="m-0 p-0 flex-col">
    <form class="flex flex-col m-0 p-8 pb-4 pb-0 rounded overflow-hidden" [formGroup]="formulario">

        <div class="flex">
            <mat-form-field class="flex-auto font-semibold">
                <mat-label>Nome e sobrenome</mat-label>
                <input matInput formControlName="nome" >
                <mat-icon matPrefix [svgIcon]="'perm_identity'"></mat-icon>
            </mat-form-field>
        </div>

        <div class="flex flex-col gt-xs:flex-row">

            <mat-form-field class="flex-auto gt-xs:pr-3 font-semibold">
                <mat-label>Usuário</mat-label>
                <input matInput formControlName="usuario" autocomplete="new-usuario">
                <mat-icon matPrefix [svgIcon]="'account_box'"></mat-icon>
            </mat-form-field>

            <mat-form-field class="flex-auto font-semibold">
                <mat-label>Senha</mat-label>
                <input matInput type="password"  formControlName="senha" autocomplete="new-password">
                <mat-icon matPrefix [svgIcon]="'lock'"></mat-icon>
            </mat-form-field>

        </div>

        <div class="flex flex-col gt-xs:flex-row">

            <mat-form-field class="flex-auto gt-xs:pr-3 font-semibold">
                <mat-label>Telefone</mat-label>
                <input matInput formControlName="telefone" [imask]="{mask: '(00) 00000-0000'}" [unmask]="false">
                <mat-icon matPrefix [svgIcon]="'phone'"></mat-icon>
            </mat-form-field>



        </div>

        <div class="flex flex-col gt-xs:flex-row">

            <mat-form-field class="flex-auto gt-xs:pr-3 font-semibold">
                <mat-label>Código do Vendedor</mat-label>
                <input matInput formControlName="codigo_vendedor" [disabled]="data.codigo != ''">
                <mat-icon matPrefix [svgIcon]="'heroicons_outline:qrcode'"></mat-icon>
            </mat-form-field>



        </div>

        <div class="flex flex-col gt-xs:flex-row">

            <mat-form-field class="flex-auto gt-xs:max-w-40 font-semibold">
                <mat-label>Tipo de chave</mat-label>
                <mat-select class="font-semibold" [(ngModel)]="tipoChave" [placeholder]="tipoChave">
                    <div class="cor-master text-center py-2">Tipo de chave</div>
                    <mat-option class="items-center" value="telefone"  (click)="setMask('telefone')">
                        <mat-icon matPrefix [svgIcon]="'mat_outline:phone'"></mat-icon>Telefone
                    </mat-option>

                    <mat-option class="items-center" value="cpf" (click)="setMask('cpf')">
                        <mat-icon matPrefix [svgIcon]="'mat_outline:perm_identity'"></mat-icon>CPF
                    </mat-option>

                    <mat-option class="items-center" value="email" (click)="setMask('email')">
                        <mat-icon matPrefix [svgIcon]="'mat_outline:email'"></mat-icon>Email
                    </mat-option>

                    <mat-option class="items-center" value="aleatoria" (click)="setMask('aleatoria')">
                        <mat-icon matPrefix [svgIcon]="'mat_outline:vpn_key'"></mat-icon>Aleatória
                    </mat-option>

                </mat-select>
            </mat-form-field>

            <mat-form-field class="flex-auto gt-xs:pl-3 font-semibold">
                <mat-label>Chave PIX</mat-label>
                <input matInput formControlName="chave_pix" [imask]="maskOptions" [unmask]="false" [disabled]="tipoChave == ''">
                <mat-icon matPrefix [svgIcon]="'heroicons_outline:qrcode'"></mat-icon>
            </mat-form-field>



        </div>


        </form>
</mat-dialog-content>



<div class="botoes shadow-xs">
    <!-- Discard -->
    <button mat-button class="mr-2 cancelar" mat-button (click)="fecharDialog()">
        <span>Cancelar</span>
    </button>

    <!-- Save as draft -->
    <button mat-flat-button [disabled]="!span || formulario.invalid" [ngClass]="{'gray-300' : formulario.invalid, 'green-600' : formulario.valid}" (click)="salvar(formulario)" class="ml-2 mr-2" mat-button>
        <span *ngIf="span && data.editando == false">Criar</span>
        <span *ngIf="span && data.editando == true">Salvar</span>
        <mat-progress-spinner color="black" *ngIf="!span" [diameter]="24" [mode]="'indeterminate'">
        </mat-progress-spinner>
    </button>

</div>
